export default {"src":"/_next/static/media/heartHalf_24.dfadcc3d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};